"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MigrationTransformBase_1 = require("./MigrationTransformBase");

var object_1 = require("../../utils/object");

var JSPath = require("jspath");

var MoveTransform =
/** @class */
function (_super) {
  __extends(MoveTransform, _super);

  function MoveTransform() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(MoveTransform.prototype, "type", {
    get: function get() {
      return 'move';
    },
    enumerable: true,
    configurable: true
  });

  MoveTransform.prototype.up = function (seed) {
    var _a = this.options,
        oldKey = _a.oldKey,
        oldParentJsPath = _a.oldParentJsPath,
        newKey = _a.newKey,
        newParentJsPath = _a.newParentJsPath;
    return this.move(seed, oldKey, newKey, oldParentJsPath, newParentJsPath);
  };

  MoveTransform.prototype.down = function (seed) {
    var _a = this.options,
        oldKey = _a.oldKey,
        oldParentJsPath = _a.oldParentJsPath,
        newKey = _a.newKey,
        newParentJsPath = _a.newParentJsPath;
    return this.move(seed, newKey, oldKey, newParentJsPath, oldParentJsPath);
  };

  MoveTransform.prototype.move = function (seed, oldKey, newKey, oldParentJsPath, newParentJsPath) {
    var clone = object_1.deepMergeObjects({}, seed);
    var oldParents = oldParentJsPath ? JSPath.apply(oldParentJsPath, clone) : [clone];

    for (var _i = 0, oldParents_1 = oldParents; _i < oldParents_1.length; _i++) {
      var oldParent = oldParents_1[_i];
      var oldValue = oldParent[oldKey];
      var newParents = newParentJsPath ? JSPath.apply(newParentJsPath, clone) : [clone];

      for (var _a = 0, newParents_1 = newParents; _a < newParents_1.length; _a++) {
        var newParent = newParents_1[_a];

        if (newParentJsPath === oldParentJsPath) {
          if (newParent === oldParent) {
            newParent[newKey] = oldValue;
            delete oldParent[oldKey];
          }
        } else {
          newParent[newKey] = oldValue;
          delete oldParent[oldKey];
        }
      }
    }

    return clone;
  };

  return MoveTransform;
}(MigrationTransformBase_1.MigrationTransformBase);

exports.MoveTransform = MoveTransform;